import type { SxProps, Theme } from '@mui/material';

export const styles = {
    paper: {
        p: { xs: 1.5, md: 3 },
        height: '100%',
        overflow: 'auto',
    } as SxProps<Theme>,
    title: {
        textAlign: 'center',
        fontSize: '20px',
        fontWeight: 400,
        color: 'grey.900',
        mb: 2,
    } as SxProps<Theme>,
    sectionLabel: {
        fontSize: '12px',
        fontWeight: 600,
        color: 'grey.700',
        textTransform: 'uppercase',
        mt: 1,
        mb: 0.5,
    } as SxProps<Theme>,
    fields: {
        display: 'flex',
        flexDirection: 'column',
        gap: 2.5,
    } as SxProps<Theme>,
    notesHint: {
        fontSize: '12px',
        color: 'grey.500',
        mt: 0.5,
    } as SxProps<Theme>,
    actions: {
        display: 'flex',
        justifyContent: 'flex-end',
        gap: 1,
        mt: 3,
    } as SxProps<Theme>,
    saveBtn: (theme: Theme): SxProps<Theme> => ({
        backgroundColor: theme.palette.blue[700],
        color: theme.palette.white,
        textTransform: 'none',
        '&:hover': { backgroundColor: theme.palette.blue[800] },
    }),
};
